module.exports = __webpack_public_path__ + "img/robotA.1c896c58.png";